export default function (img: string) {
  if (img) {
    if (img.indexOf("base64,") !== -1) {
      return img;
    }
    if (img.indexOf("http") !== -1) {
      return img;
    }
    if (img) {
      return `https://data.taisam.cn${img}`;
    }
    return "https://data.taisam.cn/assets/noimage.png";
  }
  return "https://data.taisam.cn/assets/noimage.png";
}
